import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% { background-color: #f0f0f0; }
  50% { background-color: #e0e0e0; }
  100% { background-color: #f0f0f0; }
`;

const SkeletonCardGrouping = styled.div`
  margin: 0 auto;
  max-width: 2200px;
  padding: 2rem 4rem;

  @media (max-width: 1440px) {
    padding: 2rem;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const SkeletonHeaderContainer = styled.div`
  width: 10rem;
  height: 2rem;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const SkeletonCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  padding: 1rem 0;
`;

const SkeletonCard = styled.div`
  height: 15rem;
  border-radius: 0.875rem;
  animation: ${pulse} 1.5s ease-in-out infinite;
  box-shadow: 3px 4px 4px 0px #00000040;
`;

export function StoriesSkeleton() {
  return (
    <>
      {/* Render multiple card groupings to represent weeks */}
      {[1, 2, 3].map((group) => (
        <SkeletonCardGrouping key={group}>
          <SkeletonHeaderContainer />
          <SkeletonCardsContainer>
            {/* Render multiple cards per group */}
            {Array.from({ length: 6 }, (_, i) => (
              <SkeletonCard key={i} />
            ))}
          </SkeletonCardsContainer>
        </SkeletonCardGrouping>
      ))}
    </>
  );
}
